import {Injectable} from '@angular/core';
import {Label} from "../../model/Label";
import {Information} from "../../model/information";
import {FaqCategory} from "../../model/FaqCategory";
import {InformationType} from "../../model/InformationType";
import {LabelService} from "../../services/label.service";
import {FaqCategoryService} from "../../services/faq-category.service";
import {map} from "rxjs/operators";
import {Observable, zip} from "rxjs";
import {FormGeneratorService} from "../../components/common/fields/form-generator.service";
import {FieldDefinition} from "../../model/field-definition";
import {NgbDate} from "@ng-bootstrap/ng-bootstrap";

@Injectable({
  providedIn: 'root'
})
export class InformationFormGeneratorService implements FormGeneratorService {

  constructor(private labelService: LabelService,
              private faqCategoryService: FaqCategoryService) {
  }

  getQuestions(info: Information): Observable<FieldDefinition<any>[]> {
    return zip(
      this.labelService.getObjects(),
      this.faqCategoryService.getAllCategories()
    ).pipe(
      map(pairs => {
        const d = new Date();
        let questions = [
          new FieldDefinition<string>({
            key: "title",
            label: 'Titre du message d\'information',
            type: 'text',
            value: info.title,
            required: true,
            placeholder: 'Exemple: : Mise à jour DGCL',
            order: 1
          }),
          new FieldDefinition<string>({
            key: "type",
            label: 'Type d\'information',
            type: 'btn-radio',
            value: info.type,
            required: true,
            options: [
              {key: InformationType.PINNED, value: "Épinglée"},
              {key: InformationType.DIRECT, value: "Direct"},
            ],
            order: 2
          }),
          new FieldDefinition<Label[]>({
            key: 'labels',
            label: 'Label(s) du message',
            type: 'select2',
            placeholder: 'Sélectionner le(s) label(s) concerné(s)',
            value: info.labels,
            multiple: true,
            required: false,
            options: pairs[0],
            order: 3
          }),
          new FieldDefinition<FaqCategory[]>({
            key: 'categories',
            label: 'Logiciel(s) concerné(s)',
            type: 'select2',
            placeholder: 'Sélectionner le(s) logiciel(s) concerné(s)',
            multiple: true,
            required: true,
            value: info.categories,
            options: pairs[1],
            order: 4
          }),
          new FieldDefinition<string>({
            key: "description",
            label: 'Message',
            type: 'editor',
            value: info.description,
            required: true,
            order: 5
          }),
          new FieldDefinition<string>({
            key: "endDate",
            label: 'Date de fin de publication',
            type: 'date',
            placeholder: 'jj/mm/aaaa',
            value: info.endDate ? new Date(info.endDate).toISOString().split('T')[0] : '',
            required: false,
            order: 6,
            payload: new Date().toISOString().split('T')[0]
          })
        ];
        return questions.sort((a, b) => a.order - b.order);
      })
    );
  }
}
